import React from "react";
import Modal from "./Modal";
// import { setNotification } from "../../helpers/notification";
import moment from "moment";
import Loading from "../Loading";
import {
  convertAmountToFrontend,
  convertNumberToFrontend,
} from "../../helpers/convert";
import TitleValue from "../TitleValue/TitleValue";
import { Select, Textarea } from "../Inputs";
import Button from "../Button";
import { useTranslation } from "react-i18next";

export default function CanceledMatchModal(props) {
  const { t } = useTranslation();

  const {
    offerId,
    offerPrice,
    offerQuantity,
    matchDate,
    price,
    quantity,
    contractName,
    isOpen,
    toggle,
    matchStatusDescription,
  } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <>
        <div className="km__p--certificate-edit-body">
          <TitleValue
            title={t("pages.default.offersAndMatches.offerId")}
            value={offerId}
            size="lg"
          />
          <TitleValue
            title={t("pages.default.offersAndMatches.offerPrice")}
            value={convertNumberToFrontend({ num: offerPrice, digit: 2 })}
            size="lg"
          />
          <TitleValue
            title={t("pages.default.offersAndMatches.offerQuantity")}
            value={convertAmountToFrontend(quantity)}
            size="lg"
          />
          <TitleValue
            title={t("pages.default.offersAndMatches.matchPrice")}
            value={convertNumberToFrontend({ num: price, digit: 2 })}
            size="lg"
          />
          <TitleValue
            title={t("pages.default.offersAndMatches.matchAmount")}
            value={offerQuantity}
            size="lg"
          />
          <TitleValue
            title={t("pages.default.offersAndMatches.matchDate")}
            value={moment(matchDate).format("DD.MM.YYYY HH:mm:ss")}
            size="lg"
          />
          <TitleValue
            title={t("pages.default.offersAndMatches.contract")}
            value={contractName}
            size="lg"
          />
          <Textarea
            label={t("pages.default.offersAndMatches.cancelDescription")}
            name="description"
            disabled
            value={matchStatusDescription}
            // value={
            //   editedCertificateChanges.certificateStatus === "CANCEL"
            //     ? editedCertificateChanges.description
            //     : ""
            // }
            // maxLength="255"
            // disabled={editedCertificateChanges.certificateStatus === "REPEAL"}
            // onChange={editCertificateChange}
          />
          <Select
            label={t("pages.default.offersAndMatches.status")}
            name="certificateStatus"
            // defaultValue={"sd"}
            options={[
              // { name: "", value: "-", disabled: true },
              {
                name: t("pages.default.offersAndMatches.wrong"),
                value: "CANCEL",
              },
            ]}
            // onChange={editCertificateChange}
          />
        </div>
        <div className="km__p--certificate-edit-footer">
          <Button
            label={t("pages.default.offersAndMatches.close")}
            type="primary"
            onClick={toggle}
          />
        </div>

        {/* {!marketMatchId && (
          <div className="km__c--modal-certificate-loading">
            <Loading />
          </div>
        )} */}
      </>
    </Modal>
  );
}
